export const getProductCounts = (newLineItemsRequested, includeCancelled) => {
  const nonCancelledCount = newLineItemsRequested.filter(item => !item.cancelled_from_draft).length
  const cancelledCount = newLineItemsRequested.filter(item => item.cancelled_from_draft).length
  const productsToSendCount = includeCancelled ? nonCancelledCount + cancelledCount : nonCancelledCount

  return { nonCancelledCount, cancelledCount, productsToSendCount }
}

export const getAdjustedPendingAmount = (basePendingAmount, newLineItemsRequested, includeCancelled) => {
  const absoluteBasePendingAmount = Math.abs(basePendingAmount || 0)

  if (!includeCancelled) return absoluteBasePendingAmount

  const cancelledItemsTotal = newLineItemsRequested
    .filter(item => item.cancelled_from_draft)
    .reduce((sum, item) => sum + Number(item.price || 0), 0)

  return absoluteBasePendingAmount + cancelledItemsTotal
}
